<template>
    <div class="main">
        <div v-for="(item, index) in lang" :key="index">
            <!-- 横幅 -->
            <div class="title">
                <span> {{ item[10] }}</span>
            </div>
            <!-- 活动的地方 -->
            <div class="sudoku-container">
                <section>
                    <Monopoly @handleFinish="handleFinish" @change="lotteryChange" :awardList="awardList" :isOnRound="isOnRound"></Monopoly>
                </section>
            </div>
            <!-- 右上角的！ -->
            <!-- <div class="tipBtn" @click="showPage = 'tip'">
                <img src="@/assets/images/illustrate_entrance.png" alt="" />
            </div> -->
            <!-- 右上角说明  -->
            <div class="loggedWrap" v-show="showPage == 'tip'">
                <div class="logged">
                    <div class="btn" @click="showPage = ''">{{ item[9] }}</div>
                    <div class="tipText">
                        <h3>{{ item[0] }}</h3>
                        <p></p>
                        <div>
                            <span v-html="detailMsg"></span>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 礼物展示 -->
            <div class="loggedWrap" v-show="showPage == 'gift'">
                <div class="giftWrap">
                    <h3>{{ item[2] }}</h3>
                    <div class="awardListWrap">
                        <div class="imgWrap" v-for="val in showList.slice(0, 3)" :key="val.order">
                            <img :src="val.prize_img" alt="" />
                        </div>
                    </div>
                    <div class="awardListWrap" v-show="showList.length > 3">
                        <div class="imgWrap" v-for="val in showList.slice(3, 6)" :key="val.order">
                            <img :src="val.prize_img" alt="" />
                        </div>
                    </div>
                    <div class="btn" @click="handleOk('gift')">{{ item[11] }}</div>
                </div>
            </div>
            <!-- 分享 -->
            <div class="loggedWrap" v-show="showPage == 'share'">
                <div class="shareWrap">
                    <h3>{{ item[4] }}</h3>
                    <div class="sharewrap">
                        <div class="textDiv"></div>
                        <div @click="onShare('facebook')" style="display: inline-block">
                            <img src="@/assets/images/btn_fb.png" alt="" />
                        </div>
                        <div @click="onShare('twitter')" style="display: inline-block">
                            <img src="@/assets/images/btn_twitter.png" alt="" />
                        </div>
                        <div @click="onShare('line')" style="display: inline-block">
                            <img src="@/assets/images/btn_line.png" alt="" />
                        </div>
                        <div class="quits" @click="handleOk('share')">
                            {{ item[5] }}
                        </div>
                    </div>
                </div>
            </div>
            <!-- 登录 -->
            <div class="loggedWrap" v-show="showPage == 'login'">
                <div class="loginWrap">
                    <div class="ftl">
                        <div class="beLogin">{{ item[12] }}</div>
                        <div class="loginType">
                            <div @click="onLogin('facebook')" style="display: inline-block">
                                <img src="@/assets/images/btn_fb.png" alt="" />
                            </div>
                            <div @click="onLogin('twitter')" style="display: inline-block">
                                <img src="@/assets/images/btn_twitter.png" alt="" />
                            </div>
                            <!-- <div @click="onLogin('line')" style="display: inline-block">
                                <img src="@/assets/images/btn_line.png" alt="" />
                            </div> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { myHTTP } from '../utils/net'
import queryString from 'query-string'
import Monopoly from '@/components/monopoly'
import { lang } from '@/tool/lang'
import arrList from '@/data/prize.js'
import { v4 as uuidv4 } from 'uuid'
var parsed = queryString.parse(location.search || '') || {}
export default {
    props: ['language'],
    components: {
        Monopoly
    },
    data() {
        let loginURL = 'https://test-mail.survivorio.com/api/v1/thirdparty/auth'
        if (window.location.href.indexOf('https://test-reserve.survivorio.com') === 0) {
            loginURL = 'https://test-mail.survivorio.com/api/v1/thirdparty/auth'
        } else if (window.location.href.indexOf('https://reserve.survivorio.com') === 0) {
            loginURL = 'https://mail.survivorio.com/api/v1/thirdparty/auth'
        }

        return {
            isOnRound: false,
            bingoList: [],
            loginURL,
            userId: '',
            d: '',
            showPage: '',
            lang: [{}],
            detailMsg: '',
            awardList: [],
            showList: []
        }
    },
    created() {
        this.initWard()
        if (parsed.d) {
            localStorage.setItem('d', window.location.search.split('?')[1].split('&')[0].slice(2))
            this.init()
        } else if (localStorage.getItem('d')) {
            this.init()
        } else {
            this.showPage = 'login'
        }
        // if (!localStorage.getItem('uuid')) {
        //     localStorage.setItem('uuid', uuidv4())
        // } else {
        //     this.init()
        // }
        for (var i in lang) {
            this.lang[0][i] = lang[i][this.language]
        }
    },
    mounted() {
        this.detailMsg = this.lang[0][1]
        // window.fbAsyncInit = () => {
        //     FB.init({
        //         appId: '250812872464647',
        //         cookie: true, // Enable cookies to allow the server to access the session.
        //         xfbml: true, // Parse social plugins on this webpage.
        //         version: 'v14.0' // Use this Graph API version for this call.
        //     })
        // }
    },
    methods: {
        onShare(shareType) {
            console.log(shareType)
            let str = 'share_' + shareType
            thinkingdata.track('christmas_2022', {
                step: str
            })

            let myGameURL = 'https://reserve.survivorio.com/christmas/index.html'
            let title = encodeURIComponent(title)

            if (window.location.host.indexOf('test') > -1) {
                myGameURL = 'https://test-reserve.survivorio.com/christmas/index.html'
            }

            if (location.hostname.match(/[0-9]+\.[0-9]+\.[0-9]+\.[0-9]+/)) {
                myGameURL = 'https://test-reserve.survivorio.com/christmas/index.html'
            }

            if (shareType == 'facebook') {
                let facebookShareURL = 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(myGameURL)
                window.open(facebookShareURL)
            } else if (shareType == 'twitter') {
                let twitterShareURL = 'https://twitter.com/intent/tweet?url=' + encodeURIComponent(myGameURL)
                window.open(twitterShareURL)
            } else {
                let naverShareUrl = 'https://share.naver.com/web/shareView?url=' + myGameURL + '&title=' + title
                window.open(naverShareUrl)
            }

            this.showPage = ''
            this.isOnRound = true
        },
        handleOk(val) {
            if (val == 'gift') {
                if (this.showList.length < 4) {
                    this.showPage = 'share'
                }
            } else if (val == 'share') {
                this.$emit('handleFinish', this.bingoList)
            }
        },
        getShowList(val) {
            let arr = []
            val.map(item => {
                arr.push(arrList[item - 1])
            })
            this.showList = arr
        },
        handleFinish(val) {
            this.bingoList = val
            if (val.length < 4) {
                this.getShowList(val)
                this.showPage = 'gift'
            } else {
                this.$emit('handleFinish', val)
            }
        },
        initWard() {
            setTimeout(() => {
                this.awardList = arrList
            }, 0)
        },
        lotteryChange(action, item) {
            // start fin 的行为反馈
            // console.log(action, item)
        },
        onLogin(loginType) {
            location.href = this.loginURL + '/' + loginType
        },
        init() {
            if (localStorage.getItem('myGiftCode')) {
                localStorage.removeItem('myGiftCode')
            }
            let uuid = localStorage.getItem('d')
            myHTTP
                .post('/api/v1/christmases2022/fetch', {
                    uuid,
                    giftCode: 'HappyHoliday2022'
                })
                .then(res => {
                    if (res.data.code == 0) {
                        if (res.data.data.myGiftCode) {
                            console.log('有礼包码')
                            localStorage.setItem('myGiftCode', res.data.data.myGiftCode)
                            let val = []
                            arrList.map(item => {
                                res.data.data.activityData.r.map(it => {
                                    if (item.prize_id == it) {
                                        val.push(item.order)
                                    }
                                })
                            })
                            this.$emit('handleFinish', val) // val 数组
                        } else {
                            if (!this.bingoList.length == 3 && !this.bingoList.length == 6) {
                                this.showPage = 'tip'
                            }
                        }
                    } else {
                        console.log(res.data.message)
                    }
                })
        }
    }
}
</script>

<style scoped lang="less">
@import url('../assets/styles/reset.css');
.sudoku-container {
    width: 100%;
    height: 100vh;
    display: inline-block;
    section {
        width: 100%;
        height: 100%;
        margin-top: 3rem;
    }
}

.main {
    position: relative;
    height: 100vh;
    width: 100%;
    // background: url('../assets/images/christmasbg.jpg') 100% 100% no-repeat;
    // background-size: 100% 100%;
    text-align: center;
    line-height: 1;
    padding-top: 14%;
    .title {
        width: 92%;
        background: url('../assets/images/titlebg.png') 100% 100% no-repeat;
        background-size: 100% 100%;
        font-size: 4.375rem;
        margin: 0 auto !important ;
        min-height: 16.3125vh;
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding: 0 12%;
        color: #ffffff;
        font-weight: 800;
        text-shadow: 1px 1px 1px #000;
    }
    .tipBtn {
        position: absolute;
        top: 0;
        right: 3.25rem;
        img {
            width: 6.25rem;
        }
    }

    .loggedWrap {
        width: 100%;
        height: 100vh;
        position: absolute;
        top: 0;
        left: 0;
        background: rgba(0, 0, 0, 0.6);
        line-height: 1.2;
        // 规则信息
        .logged {
            position: absolute;
            width: 90%;
            height: 68.75vh;
            top: 44%;
            left: 50%;
            transform: translate(-50%, -50%);
            background: url('../assets/images/illustrate_board_bg.png') 100% 100% no-repeat;
            background-size: 100% 100%;
            text-align: center;
            border-radius: 1.5rem;
            padding: 1.125rem 2.125rem 3.25rem;
            color: #ffffff;
        }
        @media screen and (min-width: 768px) {
            .logged {
                padding-top: 0 !important;
            }
        }
        @media screen and (min-width: 1023px) {
            .logged {
                padding-top: 1% !important;
            }
        }
        .btn {
            font-size: 4.2rem;
            font-weight: 800;
            position: absolute;
            bottom: -16%;
            left: 50%;
            transform: translateX(-50%);
            height: 8.75rem;
            min-width: 16rem;
            background: url('../assets/images/okbg.png') 100% 100% no-repeat;
            background-size: 100% 100%;
            text-align: center;
            line-height: 8.75rem;
            text-shadow: 1px 1px 1px #000;
            color: white;
            padding: 0 4rem;
            display: inline-block;
        }
        @media screen and (min-width: 768px) {
            .btn {
                bottom: -24%;
            }
        }
        .tipText {
            overflow: scroll;
            height: 100%;
            display: flex;
            flex-flow: column;
            font-size: 2.25rem;
            font-weight: 400;
            padding: 0 1rem;
            text-align: left;
            line-height: 1.5;
            h3 {
                text-align: center;
                padding: 0 0 4rem;
                font-size: 4.2rem;
                font-weight: 800;
                text-shadow: 1px 1px 1px #000;
            }
            p {
                height: 32.75rem;
            }
            div {
                padding: 3.75rem 1.875rem;
                background: #7518b9;
                border-radius: 1.5rem;
                overflow: scroll;
            }
        }

        // 登录信息
        .loginWrap {
            position: absolute;
            width: 90%;
            min-height: 22.75vh;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            background: url('../assets/images/loginbg.png') 100% 100% no-repeat;
            background-size: 100% 100%;
            .ftl {
                padding: 2.25rem;
                display: flex;
                flex-direction: column;
                height: 100%;
                .beLogin {
                    color: #ffffff;
                    text-shadow: 1px 1px 1px #000;
                    font-weight: 800;
                    font-size: 3.5rem;
                }
                .loginType {
                    flex: 1;
                    padding: 6rem 0 4rem;
                    margin-top: 1.25rem !important;
                    div:nth-child(2) {
                        margin: 0 2.5rem !important;
                    }
                    img {
                        width: 9.125rem;
                    }
                }
            }
        }

        //礼物展示
        .giftWrap {
            position: absolute;
            width: 90%;
            min-height: 52.75vh;
            top: 44%;
            left: 50%;
            transform: translate(-50%, -50%);
            background: url('../assets/images/giftbg.png') 100% 100% no-repeat;
            background-size: 100% 100%;
            h3 {
                color: #ffffff;
                text-shadow: 1px 1px 1px #000;
                font-weight: 800;
                font-size: 3.5rem;
                padding: 2.25rem 4rem 4rem;
                margin-top: 26.75rem !important;
            }
            @media screen and (min-width: 768px) {
                h3 {
                    margin-top: 14.75rem !important;
                }
            }
            @media screen and (min-width: 1023px) {
                h3 {
                    margin-top: 18.75rem !important;
                }
            }
            // 奖励展示
            .awardListWrap {
                padding: 0 10.5rem 2.25rem;
                width: 100%;
                display: flex;
                justify-content: space-around;
                .imgWrap {
                    width: 100%;
                    padding: 0.625rem 0.375rem;
                    width: 12.5rem;
                    // background: url('../assets/images/itembg.png') 100% 100% no-repeat;
                    // background-size: 100% 100%;
                    img {
                        width: 100%;
                    }
                }
            }
        }

        // 分享
        .shareWrap {
            position: absolute;
            width: 90%;
            min-height: 64.75vh;
            top: 50%;
            left: 52%;
            transform: translate(-50%, -50%);
            background: url('../assets/images/sharebg.png') 100% 100% no-repeat;
            background-size: 100% 100%;
            padding-right: 4rem;
            padding-bottom: 2.5rem;
            .sharewrap {
                padding: 1rem 0;
                .textDiv {
                    padding: 0 4rem;
                }
                div:nth-child(3) {
                    margin: 0 3.75rem !important;
                }
                img {
                    margin-top: 1.75rem;
                    width: 9.125rem;
                }
                .quits {
                    background: url('../assets/images/quitbg.png') 100% 100% no-repeat;
                    background-size: 100% 100%;
                    color: #ffffff;
                    text-shadow: 1px 1px 1px #000;
                    font-weight: 800;
                    font-size: 3.5rem;
                    padding: 2rem 6rem;
                    min-width: 26.25rem;
                    display: inline-block;
                    margin-top: 1.875rem !important;
                }
            }
            h3 {
                color: #ffffff;
                text-shadow: 1px 1px 1px #000;
                font-weight: 800;
                font-size: 3.5rem;
                margin-top: 36.75rem !important;
                padding: 2.25rem 4rem 1rem;
            }
        }
        @media screen and (min-width: 768px) and(max-width:1023px) {
            .shareWrap {
                min-height: 44.75vh;
                h3 {
                    margin-top: 26.75rem !important;
                    font-size: 2.5rem;
                }
            }
        }
        @media screen and (min-height: 900px) {
            .shareWrap {
                min-height: 46.75vh;
                h3 {
                    margin-top: 32.75rem !important;
                    font-size: 2.5rem;
                }
            }
        }
    }
}
@media screen and (min-width: 768px) {
    .main {
        padding-top: 2%;
    }
    .sudoku-container {
        section {
            margin-top: 1rem;
        }
    }
}
@media screen and (min-width: 1023px) {
    .main {
        padding-top: 4%;
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/main.vue